<template>
  <div class="form_config">
    <tip-switch
      :title="switchTip"
      :content="openTipTxt"
      :value="switchConfig"
      :disabled="isSeting"
      @change="toOpenSwitch"
    />
    <div class="config_main">
      <field-item :field="FormNedField">
        <div class="item_content-btn">
          <a-button @click="showEdit = true">
            {{ $t('message["36"]') }}
          </a-button>
          <span class="content_tip"> {{ $t('message["124"]') }}</span>
        </div>
        <div
          v-if="defaultFields.length > 0"
          class="fields"
        >
          <a-tag
            v-for="field in defaultFields"
            :key="field.id"
            v-text="field.fieldname"
          />
        </div>
        <div
          v-else
          class="fields"
        >
          <p class="tag_null">
            {{ $t('message["1553"]') }}
          </p>
        </div>
      </field-item>
      <field-item :field="`IP${blockListTit}`">
        <div class="item_content-btn">
          <self-switch
            :value="IpSwitch"
            :disabled="isSeting"
            @change="openIpLimit"
          />
          <span class="content_tip ip_tip">{{ $t('message["555"]') }}</span>
        </div>
        <div class="ips">
          <div class="ips_main">
            <p
              v-if="IpList.length === 0"
              class="ip_list ips_null scroll_bar_beautify_ff"
            >
              {{ $t('message["1553"]') }}
            </p>
            <ul
              v-if="IpList.length > 0"
              class="ip_list"
            >
              <li
                v-for="(ip, index) in IpList"
                :key="ip"
                class="clearfix"
              >
                <span v-text="ip" />
                <i
                  class="iconfont iconicon-test8"
                  @click="deleteIp(ip, index)"
                />
              </li>
            </ul>
            <div
              :class="['add_ip', !addIP ? 'dashed' : '']"
              @click.stop="addIP = true"
            >
              <div
                v-if="addIP"
                class="add_form"
              >
                <a-input
                  v-model="currentIP"
                  :placeholder="ipTitTxt"
                />
                <span
                  class="primary"
                  @click.stop="hadleSubmitIp"
                >
                  {{ $t('message["915"]') }}
                </span>
                <span
                  class="cancel"
                  @click.stop="initAddIps"
                >{{ $t('message["896"]') }}</span>
              </div>
              <span
                v-else
                class="add_text"
              >{{ $t('message["1190"]') }}</span>
            </div>
          </div>
        </div>
      </field-item>
    </div>
    <edit-fields-modal
      v-if="showEdit"
      :visible.sync="showEdit"
    />
  </div>
</template>

<script type="text/ecmascript-6">
import tipSwitch from './components/TipTool'
import selfSwitch from './components/Switch'
import fieldItem from './components/FieldMain'
import editFieldsModal from './components/editFields'
import { mapState, mapActions } from 'vuex'
export default {
  components: {
    tipSwitch,
    selfSwitch,
    fieldItem,
    editFieldsModal
  },
  data () {
    return {
      addIP: false,
      form: this.$form.createForm(this),
      showEdit: false,
      currentIP: ''
    }
  },
  computed: {
    ...mapState('config/smart', ['baseConfig', 'isSeting', 'loading']),
    ...mapState(['baseinfo']),
    // 是否开启了混合云
    priviteCloud () {
      return this.baseinfo.private_cloud_status === 1
    },
    switchConfig () {
      return this.baseConfig.is_auto_insert === 1
    },
    IpSwitch () {
      return this.baseConfig.is_black_ip === 1
    },
    IpList () {
      return this.baseConfig.black_ip_list || []
    },
    defaultFields () {
      if ((Object.keys(this.baseConfig).length > 0)) {
        return ('default' in this.baseConfig && this.baseConfig.default.map(item => {
          return { id: item.id, fieldname: item.fieldname }
        })) || []
      } else {
        return []
      }
    },
    FormNedField () {
      return this.$t('message["54"]')
    },
    blockListTit () {
      return this.$t('message["433"]')
    },
    openTipTxt () {
      return this.$t('message["556"]')
    },
    ipTitTxt () {
      return this.$t('message["755"]')
    },
    switchTip () {
      return this.$t('message["1169"]')
    }
  },
  methods: {
    ...mapActions('config/smart', ['setFormConfig', 'delIP']),
    toOpenSwitch (value) {
      if (this.priviteCloud) {
        this.$warning({
          title: this.$t('message["170"]')
        })
      } else {
        this.setConfig({ 'is_auto_insert': value ? 1 : 0 })
      }
    },
    openIpLimit (value) {
      this.setConfig({ 'is_black_ip': value ? 1 : 0 })
    },
    deleteIp (ip, index) {
      const _this = this
      _this.$confirm({
        title: this.$t('message["916"]') + '？',
        iconType: 'info-circle',
        closable: true,
        onOk () {
          _this.deleteIP({ black_ip_list: ip, index })
        },
        onCancel () {
          // _this.initAddIps()
        }
      })
    },
    initAddIps () {
      this.$set(this._data, 'addIP', false)
      this.$set(this._data, 'currentIP', '')
    },
    hadleSubmitIp () {
      // IPV6: /^([\da-fA-F]{1,4}:){7}[\da-fA-F]{1,4}$/
      const IpReg = /^((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)$/
      if (IpReg.test(this.currentIP)) {
        this.setConfig({ 'black_ip_list': this.currentIP })
        this.$set(this._data, 'currentIP', '')
      } else {
        this.$message.warning(`IP ${this.$t('message["363"]')}！`)
      }
    },
    async setConfig (params) {
      await this.setFormConfig(params)
    },
    async deleteIP (params) {
      await this.delIP(params)
    }
  }
}
</script>

<style scoped lang="scss">
.form_config {
  margin: 24px 0;
  .config_main {
    margin: 24px 0;
    .content_tip {
      color: #b3b3b3;
      line-height: 24px;
      vertical-align: middle;
    }
    .ip_tip {
      margin: 0 16px;
    }
    .fields {
      max-width: 500px;
      margin: 15px 0 0 0;
      .ant-tag {
        margin: 12px 12px 0 0;
      }
    }
    .tag_null,
    .ips_null {
      line-height: 24px;
      color: #666;
    }
    .ips {
      width: 320px;
      max-height: 312px;
      border-radius: 4px;
      border: 1px solid #e0e0e0;
      margin: 24px 0 0 0;
      .ips_main {
        position: relative;
        margin: 8px;
        .ips_null {
          text-align: center;
        }
        .ip_list {
          color: #666;
          height: 256px;
          overflow-x: hidden;
          overflow-y: auto;
          li:last-of-type {
            margin-bottom: 32px;
          }
          li {
            line-height: 24px;
            padding: 4px 8px;
            .iconfont {
              display: none;
              color: #d6d6d6;
              float: right;
              font-size: 16px;
            }
          }
          li:hover {
            cursor: pointer;
            border-radius: 4px;
            background: #f4f7f9;
          }
          li:hover .iconfont {
            display: block;
          }
        }
        .dashed {
          border: 1px dashed #e0e0e0;
          text-align: center;
        }
        .add_ip {
          position: absolute;
          bottom: 0;
          width: 100%;
          height: 32px;
          border-radius: 4px;
          background: #fff;
          .add_text {
            line-height: 32px;
            color: #5077aa;
          }
          .add_form {
            overflow: hidden;
            input {
              width: 168px;
            }
            .primary,
            .cancel {
              display: inline-block;
              width: 52px;
              height: 100%;
              line-height: 32px;
              text-align: center;
              background: #ebebeb;
              box-shadow: 0 2px 0 0 rgba(255, 255, 255, 0.5);
              border-radius: 4px;
              margin-left: 14px;
              margin-right: 0;
              box-sizing: border-box;
              border: 1px solid #ebebeb;
            }
            .primary {
              background: linear-gradient(360deg, #5077aa 0%, #608fcc 100%);
              border: 1px solid #5077aa;
              color: #fff;
            }
            .primary:hover,
            .cancel:hover {
              cursor: pointer;
            }
            .primary:hover {
              background: linear-gradient(360deg, #608fcc 0%, #5077aa 100%);
            }
          }
        }
        .add_ip:hover {
          cursor: pointer;
        }
      }
    }
    .save {
      margin: 24px 0;
    }
  }
}
</style>
